module.exports = __webpack_public_path__ + "static/media/img_refuse.68b296e3.svg";